import { ReactComponent as GB } from '../../icons/countries/GB.svg';
import { ReactComponent as AT } from '../../icons/countries/AT.svg';
import { ReactComponent as BE } from '../../icons/countries/BE.svg';
import { ReactComponent as BG } from '../../icons/countries/BG.svg';
import { ReactComponent as HR } from '../../icons/countries/HR.svg';
import { ReactComponent as CY } from '../../icons/countries/CY.svg';
import { ReactComponent as CZ } from '../../icons/countries/CZ.svg';
import { ReactComponent as DK } from '../../icons/countries/DK.svg';
import EE from '../../icons/countries/EE.svg';
import { ReactComponent as FI } from '../../icons/countries/FI.svg';
import { ReactComponent as FR } from '../../icons/countries/FR.svg';
import { ReactComponent as DE } from '../../icons/countries/DE.svg';
import { ReactComponent as GR } from '../../icons/countries/GR.svg';
import { ReactComponent as HU } from '../../icons/countries/HU.svg';
import { ReactComponent as IE } from '../../icons/countries/IE.svg';
import { ReactComponent as IT } from '../../icons/countries/IT.svg';
import { ReactComponent as LV } from '../../icons/countries/LV.svg';
import { ReactComponent as LT } from '../../icons/countries/LT.svg';
import { ReactComponent as LU } from '../../icons/countries/LU.svg';
import { ReactComponent as MT } from '../../icons/countries/MT.svg';
import { ReactComponent as NL } from '../../icons/countries/NL.svg';
import { ReactComponent as PL } from '../../icons/countries/PL.svg';
import { ReactComponent as PT } from '../../icons/countries/PT.svg';
import { ReactComponent as RO } from '../../icons/countries/RO.svg';
import { ReactComponent as SK } from '../../icons/countries/SK.svg';
import { ReactComponent as SI } from '../../icons/countries/SI.svg';
import { ReactComponent as ES } from '../../icons/countries/ES.svg';
import { ReactComponent as SE } from '../../icons/countries/SE.svg';
import { ReactComponent as MC } from '../../icons/countries/MC.svg';
import { ReactComponent as EU } from '../../icons/countries/EU.svg';
import { ReactComponent as CH } from '../../icons/countries/CH.svg';
import { ReactComponent as CN } from '../../icons/countries/CN.svg';
import { ReactComponent as TR } from '../../icons/countries/TR.svg';
import './Flag.scss';
import React from 'react';

interface Props {
  country: string;
  className?: string;
}

const flagsMap: {
  [key: string]: JSX.Element;
} = {
  GB: <GB />,
  AT: <AT />,
  BE: <BE />,
  BG: <BG />,
  HR: <HR />,
  CY: <CY />,
  CZ: <CZ />,
  DK: <DK />,
  EE: <img src={EE} alt='' />,
  FI: <FI />,
  FR: <FR />,
  DE: <DE />,
  GR: <GR />,
  EL: <GR />,
  HU: <HU />,
  IE: <IE />,
  IT: <IT />,
  LV: <LV />,
  LT: <LT />,
  LU: <LU />,
  MT: <MT />,
  NL: <NL />,
  PL: <PL />,
  PT: <PT />,
  RO: <RO />,
  SK: <SK />,
  SI: <SI />,
  ES: <ES />,
  SE: <SE />,
  MC: <MC />,
  EU: <EU />,
  CH: <CH />,
  CN: <CN />,
  TR: <TR />,
};

const Flag = ({ country, className = '' }: Props) => {
  return flagsMap[country] ? (
    React.cloneElement(flagsMap[country], {
      className: `Flag ${className}`,
    })
  ) : country === 'OTHER' ? null : (
    <span className={className}>{country}</span>
  );
};

export default Flag;
